export default __webpack_public_path__ + "static/media/45.87131fc5.png";